import React from 'react';
import {
  AccountBalance as OverviewIcon,
  AdminPanelSettings as AdminsIcon,
  CreditCard as PlanIcon,
  People as UsersTabIcon,
  VpnKey as SsoIcon,
  WarningAmber as DangerIcon,
} from '@mui/icons-material';
import { RootTab } from 'new/components/marketplace/components/DataProductsDrawer/components/Tabs/RootTab';
import { AdminOrg } from 'new/stores/adminOrgs/adminOrgs.types';
import { AdminRole } from '../RoleBanner';
import { CustomerOrgTabValue, useCustomerOrgDrawerTabs } from './useCustomerOrgDrawerTabs';
import { OverviewTab } from './tabs/OverviewTab';
import { PlanLimitsTab } from './tabs/PlanLimitsTab';
import { SsoIdpTab } from './tabs/SsoIdpTab';
import { UsersTab } from './tabs/UsersTab';
import { AdminsTab } from './tabs/AdminsTab';
import { DangerZoneTab } from './tabs/DangerZoneTab';
import styles from './CustomerOrgDrawer.module.scss';

interface CustomerOrgTabsProps {
  org: AdminOrg;
  role: AdminRole;
}

const TAB_ICONS: Record<CustomerOrgTabValue, React.ComponentType<{ fontSize?: 'small' }>> = {
  overview: OverviewIcon,
  plan: PlanIcon,
  sso: SsoIcon,
  users: UsersTabIcon,
  admins: AdminsIcon,
  danger: DangerIcon,
};

export function CustomerOrgTabs({ org, role }: CustomerOrgTabsProps) {
  const { activeTab, handleTabChange, tabs } = useCustomerOrgDrawerTabs(org.id);

  return (
    <div className={styles.body}>
      <div className={styles.tabRail}>
        {tabs.map((tab) => {
          const Icon = TAB_ICONS[tab.value];
          const isActive = tab.value === activeTab;
          return (
            <button
              key={tab.value}
              type="button"
              className={isActive ? styles.tabRailItemActive : styles.tabRailItem}
              onClick={(event) => handleTabChange(event, tab.value)}
            >
              <Icon fontSize="small" />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className={styles.tabContent}>
        <RootTab value="overview" activeTab={activeTab} keepMountedAfterActivation>
          <OverviewTab org={org} />
        </RootTab>

        <RootTab value="plan" activeTab={activeTab}>
          <PlanLimitsTab org={org} role={role} />
        </RootTab>

        <RootTab value="sso" activeTab={activeTab}>
          <SsoIdpTab org={org} />
        </RootTab>

        <RootTab value="users" activeTab={activeTab}>
          <UsersTab org={org} role={role} />
        </RootTab>

        <RootTab value="admins" activeTab={activeTab}>
          <AdminsTab org={org} role={role} />
        </RootTab>

        <RootTab value="danger" activeTab={activeTab}>
          <DangerZoneTab org={org} role={role} />
        </RootTab>
      </div>
    </div>
  );
}
